import React from 'react';
import { InterviewButton } from '../../../applicant/InterviewButton';
import * as S from './styles';

type Props = {
  firstName?: string | null;
  photo?: string;
};

export const UploadPreview: React.FC<Props> = ({ firstName, photo }) => {
  return (
    <S.PreviewWrapper>
      <InterviewButton
        hideDisclaimer
        state="found-vetter"
        vetter={{
          firstName: firstName || 'Helen',
          photoLowUrl: photo || '/images/avatar.svg',
        }}
        timerNode={30}
      />
    </S.PreviewWrapper>
  );
};
